(function(angular) {
    'use strict';
    
    var serviceName = 'ValidationWarnings';
    var mainRoute = 'warnings';

    angular.module('aprima-provider-api').factory(serviceName, [
        '_',
        '$q',
        'AprimaAnalytics',
        'AprimaCache',
        'AprimaRestangular',
        'ServerInfoRepository',
        'ValidationResult',
        ValidationWarnings,
    ]);

    function ValidationWarnings(
        _,
        $q,
        AprimaAnalytics,
        AprimaCache,
        AprimaRestangular,
        ServerInfoRepository,
        ValidationResult
    ) {

        var defaultCache = AprimaCache.Default.httpMode;

        var service = {
            insuranceExclusion: insuranceExclusion,
            inOfficeHours: inOfficeHours,
        };

        return service;

        function insuranceExclusion(providerId, patientId, accountId) {
            var params = {
                providerId: providerId,
                patientId: patientId,
                accountId: accountId,
            };
            var result = get('insurance-exclusion', params, 'ProviderInsuranceExclusionWarning', defaultCache);
            return result;
        }

        function inOfficeHours(calendarId, startDate, endDate) {
            var params = {
                calendarId: calendarId,
                startDate: startDate,
                endDate: endDate,
            };
            var result = get('office-hours', params, 'CalendarOfficeHoursWarning', defaultCache);
            return result;
        }

        function get(route, params, requiredFeature, cache) {
            if(requiredFeature && !ServerInfoRepository.isFeatureSupported(requiredFeature)) {
                return $q.when(new ValidationResult());
            }

            var timing = AprimaAnalytics.startTiming(serviceName, 'api', route);
            return AprimaRestangular.get()
                .one(mainRoute, route)
                .withHttpConfig({cache: cache})
                .get(params)
                .then(function(data) {
                    return ValidationResult.mapFromApi(data);
                })
                .finally(timing.stop);
        }
    }

})(window.angular);